
import { BookOpen } from "lucide-react";
import { Card } from "@/components/ui/card";
import { DimensionScores } from "../DimensionScores";
import { RadarAnalysis } from "../charts/RadarAnalysis";
import { Industry } from "@/types/assessment";

interface DimensionAnalysisProps {
  dimensionScores: Record<string, number>;
  industry: Industry;
}

export const DimensionAnalysis = ({ dimensionScores, industry }: DimensionAnalysisProps) => {
  return (
    <Card className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <BookOpen className="w-6 h-6 text-primary" />
        <h2 className="text-2xl font-bold text-primary">Comprehensive Dimension Analysis</h2>
      </div>
      <div className="space-y-6">
        <p className="text-muted-foreground">
          This analysis provides a detailed view of your organization's AI maturity across key dimensions, 
          visualized through both detailed scores and a radar chart for comprehensive understanding.
        </p>
        <DimensionScores dimensionScores={dimensionScores} />
        <RadarAnalysis dimensionScores={dimensionScores} industry={industry} />
      </div>
    </Card>
  );
};
